import(/* webpackMode: "eager" */ "/app/app/hub/page.tsx");
